import axios from 'axios'
import { isBlank } from '../../commons.js'
import State from './state.js'
import { readCookie, createCookie } from '../../lib/cookies.js'

import { Controller } from "stimulus"
export default class extends Controller {

  static targets = ["filterDate", "filterUser", "taskList", "itaskList", "sumDurations", "sumAmounts", "forcedWorkdateMsg", "dailyChart"]

  connect() {
    var chart_icon = document.getElementById('daily_chart_icon')
    var daily_chart_cookie = readCookie('daily_chart_show')
    if (daily_chart_cookie == 'no') {
      chart_icon.style.setProperty('opacity', '0.5')
      this.chart_is_visible = false
    } else {
      this.chart_is_visible = true
    }

    State.task_editor_opened = false
    State.itask_editor_opened = false
    State.filter_controller = this
    this.refreshList('all')
    this.evtL1 = this.evtRefreshList.bind(this);
    document.addEventListener('@daily-filter#refresh', this.evtL1, false); // https://stackoverflow.com/questions/11565471/removing-event-listener-which-was-added-with-bind
  }

  disconnect() {
    document.removeEventListener('@daily-filter#refresh', this.evtL1, false)
  }

  chart_icon_clicked(e) {
    e.preventDefault()
    if (isBlank(this.filterUserTarget.value) || isBlank(this.filterDateTarget.value))
      return

    var chart_icon = document.getElementById('daily_chart_icon')
    var chart_main_elem = document.getElementById('daily_chart')
    if (this.chart_is_visible) {
      chart_main_elem.style.display = "none"
      chart_icon.style.setProperty('opacity', '0.5')
      createCookie('daily_chart_show', 'no', 4000)
      this.chart_is_visible = false
    } else {
      chart_main_elem.style.display = "block"
      chart_icon.style.setProperty('opacity', '1')
      createCookie('daily_chart_show', 'yes', 4000)
      this.chart_is_visible = true
      this.displayChart()
    }
  }

  displayChart() {
    if (this.chart_is_visible) {
      var params = {
        date: this.filterDateTarget.value,
        user_id: this.filterUserTarget.value
      }
      axios.get('/daily/durations_chart', {
        params: params
      }).then(response => {
        var chart_main_elem = document.getElementById('daily_chart')
        chart_main_elem.innerHTML = ""
        chart_main_elem.insertAdjacentHTML('afterbegin', response.data)
      })
    }
  }

  // event reçu de tasks_controller.js - ou de charts_controller.js
  evtRefreshList(e) {
    this.refreshList(e.detail);
  }

  // event change : changement de la date ou de l'utilisateur dans views/daily/show.html.erb
  refresh_list(e) {
    this.refreshList('all')
  }

  refreshList(which) {
    let date = this.filterDateTarget.value
    if (which.daily_chart_date !== undefined) { // charts_controller.js
      date = which.daily_chart_date
      which = "all"
    }

    if (isBlank(this.filterUserTarget.value) || isBlank(date)) // this.filterDateTarget.value
      return

    var params = {
      date: date, // this.filterDateTarget.value
      user_id: this.filterUserTarget.value
    }

    if (this.element.dataset.widget9calldata.length) {
      params = Object.assign({}, params, { widget9calldata: JSON.parse(this.element.dataset.widget9calldata) })
      this.element.dataset.widget9calldata = ""
    }

    this.displayChart()
    axios.get('/daily/summary.json', {
      params: params
    }).then(response => {
      if (response.data.forced_work_date[0] == false) { // Saisie impossible
        this.sumDurationsTarget.innerHTML = ""
        this.sumAmountsTarget.innerHTML = ""
        this.taskListTarget.innerHTML = ""
        this.itaskListTarget.innerHTML = ""
        this.forcedWorkdateMsgTarget.style.display = "block"
        this.forcedWorkdateMsgTarget.innerHTML = response.data.forced_work_date[1]
      } else {
        this.sumDurationsTarget.innerHTML = response.data.durations
        this.sumAmountsTarget.innerHTML = response.data.amounts
        this.forcedWorkdateMsgTarget.style.display = "none"

        if (which === 'all' || which === 'tasks') {
          axios.get('/daily/tasks', {
            params: params
          }).then(response => {
            this.taskListTarget.innerHTML = response.data
          })
        }

        if (which === 'all' || which === 'itasks') {
          axios.get('/daily/itasks', {
            params: params
          }).then(response => {
            this.itaskListTarget.innerHTML = response.data
          })
        }
      }
    })
  }
}